module.exports = __webpack_public_path__ + "img/diamond.de6e49d6.png";